export function quantidadeLinhasTelefone(quantidade: number | null | undefined, linhas: unknown, fibra: boolean): number {
  return fibra ? Math.max(1, Array.isArray(linhas) ? linhas.length : 0) : quantidade || 0;
}
